import { z } from 'zod';

export const repaymentTerms = z.object({
  term: z.number(),
  // TODO: made required once frontend also sending termInMonths & made it required in the schema as well.
  termInMonths: z.number().optional(),
  amount: z.number().optional(),
  termNumberOfPayments: z.number().optional(),
  paymentRegularFirstDate: z.string().optional(),
  paymentCountRegular: z.number().optional(),
  totalInterest: z.number().optional(),
  totalPayments: z.number().optional(),
  dateMaturity: z.string().optional(),
  interestRate: z.number().optional(),
  interestCycle: z.string().trim().optional(),
  paymentCycle: z.string().trim().optional(),
});
